import { render, staticRenderFns } from "./Plotfooter.vue?vue&type=template&id=7f796fe1"
import script from "./Plotfooter.vue?vue&type=script&lang=js"
export * from "./Plotfooter.vue?vue&type=script&lang=js"
import style0 from "./Plotfooter.vue?vue&type=style&index=0&id=7f796fe1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports